import { render, staticRenderFns } from "./RoundPhotoAndName.vue?vue&type=template&id=a21d84d8&"
import script from "./RoundPhotoAndName.vue?vue&type=script&lang=js&"
export * from "./RoundPhotoAndName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports